var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',_vm._l((_vm.companiesDisplayed),function(company){return _c('thumbnail',{key:company['_id'],attrs:{"companyDetails":company,"addAliasButton":_vm.addAlias},on:{"emitAddAliasEvent":_vm.emitAddAliasEvent}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }